'use strict';

/**
 * HPE Legacy Site constants (Product Catalog only)
*/
module.exports = {
    //component class ids
    componentclass: {
        OPTIONS: 'hpe.componentclass.options',
        OVERVIEW: 'hpe.componentclass.overview',
        MODELS: 'hpe.componentclass.models',
        SERVICES: 'hpe.componentclass.services',
        SPECIFICATIONS: 'hpe.componentclass.specifications',
        COMPTATIBLEPRODUCTS: 'hpe.componentclass.compatibleproducts'
    },

    //dynamic tab container
    dynamictabcontainer: {
        CHANGE: 'hpe.dynamictabcontainer.change',
        CHILDINIT: 'hpe.dynamictabcontainer.childinit',
        LOADER_SHOW: 'hpe.dynamictabcontainer.loader.show',
        LOADER_HIDE: 'hpe.dynamictabcontainer.loader.hide',
        MOBILE_OPEN_CLOSE: 'hpe.dynamictabcontainer.mobile.open.close',
        TAB_CONTAINER_INIT: 'hpe.dynamictabcontainer.tab.container.init'
    },

    //---------------------------------------
    // Router component
    //---------------------------------------
    router: {
        'ROUTER_UPDATE_ATTR': 'hpe.router.update.params',
        'ROUTER_REMOVE_ATTR': 'hpe.router.remove.params',
        'BROWSER_URL_CHANGE': 'hpe.router.browserurl.change',
        'BROWSER_POP_STATE': 'hpe.router.browser.popstate',
        'ROUTER_UPDATE_PAGE': 'hpe.router.update.page',
        'BROWSER_PAGE_CHANGE': 'hpe.router.page.change'
    },

    catalog: {
        SPECS_CHANGE: 'hpe.catalog.specs.change',
        SHOW_SPECS_COOKIE: 'showspecs',
        VIEW_UPDATE_REQUEST: 'hpe.catalog.update.view',
        VIEW_UPDATE_RENDER: 'hpe.catalog.render.view',
        VIEW_ERROR: 'hpe.catalog.render.error',
        FILTER_COLLAPSE_CHANGE: 'hpe.catalog.render.filter',
        CATALOG_SCROLL_TOP_CHANGE: 'hpe.catalog.scroll.top.change',
        CATALOG_RESULTS_UPDATED: 'hpe.catalog.results.updated',
        SCROLLING_RENDER_UPDATE: 'hpe.catalog.scrolling.updated',
        COMPARE_LIST_CHANGE: 'hpe.catalog.compare.change',
        COMPARE_LIST_ADD: 'hpe.catalog.compare.add',
        COMPARE_LIST_REMOVE: 'hpe.catalog.compare.remove',
        COMPARE_PAGE_NAVIGATE: 'hpe.catalog.compare.navigate',
        COMPARE_STORAGE_KEY: 'catcompare',
        COMPARE_COUNT_MAX: 4,
        COMPARE_TRAY_ADD: 'hpe.catalog.compare.tray.add',
        COMPARE_TRAY_REMOVE: 'hpe.catalog.compare.tray.remove',
        COMPARE_TRAY_REMOVE_COMPLETE: 'hpe.catalog.compare.tray.remove.complete',
        COMPARE_TRAY_UPDATED: 'hpe.catalog.compare.tray.updated',
        HIT_COUNT_COOKIE: 'hitcount'
    }
};
